export default __webpack_public_path__ + "static/media/r4.2d1b97d7.jpg";